// Plan Details Dialog v2 — tokens reference.
// Each value is a CSS custom property declared in `src/index.css`.
// Inline styles reference them via `var(--pd-*)` so they participate in any
// future theming override (dark mode, brand variants).

export const PD = {
  bg: 'var(--pd-bg)',
  card: 'var(--pd-card)',
  fill: 'var(--pd-fill)',
  fillStrong: 'var(--pd-fill-strong)',
  hairline: 'var(--pd-hairline)',
  divider: 'var(--pd-divider)',
  cardEdge: 'var(--pd-card-edge)',
  ink: 'var(--pd-ink)',
  ink2: 'var(--pd-ink-2)',
  ink3: 'var(--pd-ink-3)',
  cta: 'var(--pd-cta)',
  ctaFg: 'var(--pd-cta-fg)',
  surfaceTranslucent: 'var(--pd-surface-translucent)',
  footerTranslucent: 'var(--pd-footer-translucent)',
  cardTranslucent: 'var(--pd-card-translucent)',
  lime: 'var(--pd-lime)',
  limeInk: 'var(--pd-lime-ink)',
  limeSoft: 'var(--pd-lime-soft)',
  success: 'var(--pd-success)',
  successInk: 'var(--pd-success-ink)',
  successSoft: 'var(--pd-success-soft)',
  warn: 'var(--pd-warn)',
  warnInk: 'var(--pd-warn-ink)',
  warnSoft: 'var(--pd-warn-soft)',
  danger: 'var(--pd-danger)',
  dangerInk: 'var(--pd-danger-ink)',
  dangerSoft: 'var(--pd-danger-soft)'
} as const;

export const SF = 'var(--pd-font)';
export const SFm = 'var(--pd-font-mono)';
